export * from './touren-filter.component';
export * from './touren-filter.component.module';